enum UsageStateEnum {
	NotApplicable = 'notApplicable',
	NotAvailable = 'notAvailable',
	Ready = 'ready',
	Started = 'started',
	Stopped = 'stopped',
}
export default UsageStateEnum;
